__turbopack_context__.v({
  "menucontent": "sidebar-menu-module-scss-module__1R-C3G__menucontent",
  "searchWrapper": "sidebar-menu-module-scss-module__1R-C3G__searchWrapper",
  "sidebarmenu": "sidebar-menu-module-scss-module__1R-C3G__sidebarmenu",
  "sidebarmenu1": "sidebar-menu-module-scss-module__1R-C3G__sidebarmenu1",
});
